module.exports = __webpack_public_path__ + "static/media/money.2b2ea9ac.svg";